import { Card } from '@chakra-ui/react';
import type {
	CardBodyProps, CardFooterProps, CardRootProps,
} from '@chakra-ui/react';
import React from 'react';
import type { PropsWithChildren } from 'react';

const CardWrapperRoot = ({ children, ...cardRootProps }: PropsWithChildren<CardRootProps>) => {
	return (
		<Card.Root gap={0} {...cardRootProps}>
			{children}
		</Card.Root>
	);
};

const CardWrapperBody = ({ children, ...cardBodyProps }: PropsWithChildren<CardBodyProps>) => {
	return (
		<Card.Body {...cardBodyProps}>
			{children}
		</Card.Body>
	);
};

const CardWrapperFooter = ({ children, ...cardFooterProps }: PropsWithChildren<CardFooterProps>) => {
	return (
		<Card.Footer {...cardFooterProps}>
			{children}
		</Card.Footer>
	);
};

export const CardWrapper = {
	Body:   CardWrapperBody,
	Footer: CardWrapperFooter,
	Root:   CardWrapperRoot,
};
